export default function init($router, $store) {
  const $go = {
    index() {
      $router.push('/')
    },
    login(query) {
      $router.push({ name: 'login', query })
    },
    room({ room, no, id, _contract, into = true }) {
      if (!room && id)
        room = $store.getters.room_by_id(id)
      if (!room && no)
        room = $store.getters.room(no)
      if (!room)
        return false

      if (into) {
        let contract = null
        if (_contract)
          contract = $store.getters.contract(_contract)
        if (!contract)
          contract = $store.getters.current_contract_of_room(room.no)
        if (contract) {
          $router.push(`/room/${room.no}/contract/${contract._id}`)
          return true
        }
      }

      $router.push(`/room/${room.no}`)
      return true
    },
    contract({ room_no, id }) {
      if (room_no)
        $router.push(`/room/${room_no}/contract/${id}`)
      else
        $go.room({ _contract: id })
    },
  }
  $router.$go = $go
}



// WEBPACK FOOTER //
// ./client/src/utils/gotos.js